var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h2',{staticClass:"font-medium text-xl mt-6 md:mt-0 md:text-2xl lg:text-3xl mb-6 md:mb-8 lg:mb-10"},[_vm._v("Color Input")]),_c('div',[_c('label',{staticClass:"vs-input--label"},[_vm._v("Input")]),_c('span',{staticClass:"span-text-validation-danger"},[_vm._v("Error")])])])
}]

export { render, staticRenderFns }